import React from "react"
import { IconProps } from "./interfaces/IconProps.interface"

const FolderFill = ({color, ...props}: IconProps) => {
    return (
        <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g clipPath="url(#clip0_30521_59464)">
                <path d="M23.6125 9.51022H39.9438C40.4482 9.51022 40.9321 9.71062 41.2888 10.0673C41.6455 10.424 41.8459 10.9078 41.8459 11.4123V38.0415C41.8459 38.5459 41.6455 39.0297 41.2888 39.3865C40.9321 39.7432 40.4482 39.9436 39.9438 39.9436H5.70628C5.20182 39.9436 4.71802 39.7432 4.36131 39.3865C4.0046 39.0297 3.8042 38.5459 3.8042 38.0415V7.60814C3.8042 7.10367 4.0046 6.61987 4.36131 6.26316C4.71802 5.90645 5.20182 5.70605 5.70628 5.70605H19.8083L23.6125 9.51022Z" fill={color} />
            </g>
            <defs>
                <clipPath id="clip0_30521_59464">
                    <rect width="45.65" height="45.65" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default FolderFill
